document.addEventListener("DOMContentLoaded", function () {
  const scrollContainers = document.querySelectorAll(".product-card-variants");

  if (scrollContainers.length === 0) return; // Exit if none found

  scrollContainers.forEach((container) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    // Prevent image dragging
    container.querySelectorAll("img").forEach((img) => {
      img.setAttribute("draggable", "false");
    });

    container.addEventListener("mousedown", (e) => {
      isDown = true;
      container.classList.add("dragging");
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });

    container.addEventListener("mouseleave", () => {
      isDown = false;
      container.classList.remove("dragging");
    });

    container.addEventListener("mouseup", () => {
      isDown = false;
      container.classList.remove("dragging");
    });

    container.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2;
      container.scrollLeft = scrollLeft - walk;
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const cartOpenBtns = document.querySelectorAll(".cart-open"); // Select all elements with class 'cart-open'
  const cartCloseBtn = document.querySelector(".cart-close");
  const cartPop = document.getElementById("cart-pop");
  const cartArea = document.getElementById("cart-area");

  function openCart() {
    cartPop.style.display = "block";

    // Remove #cart-show from the URL
    if (window.location.hash === "#cart-show") {
      history.replaceState(null, null, " ");
    }
  }

  // Add event listeners to all elements with the class 'cart-open'
  cartOpenBtns.forEach(function (btn) {
    btn.addEventListener("click", openCart);
  });

  cartCloseBtn.addEventListener("click", function () {
    cartPop.style.display = "none";
  });

  cartPop.addEventListener("click", function (event) {
    if (!event.target.closest("#cart-area")) {
      cartPop.style.display = "none";
    }
  });

  cartCloseBtn.addEventListener("click", function () {
    cartPop.style.display = "none";
  });

  // Check if URL ends with #cart-show
  if (window.location.hash === "#cart-show") {
    openCart();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var splideElement = document.getElementById("splidetext");

  if (splideElement) {
    var splide = new Splide("#splidetext", {
      type: "loop",
      drag: true,
      arrows: false,
      perPage: 1,
      pagination: false,
      autoplay: false,
      perMove: 1,
      gap: "10px",
      classes: {
        arrows: "splide__arrows class-arrows",
        arrow: "splide__arrow class-arrow",
        prev: "splide__arrow--prev class-prev",
        next: "splide__arrow--next class-next",
      },
    }).mount();

    // Handle custom prev buttons
    document.querySelectorAll('.class-prev').forEach(button => {
      button.addEventListener('click', () => {
        splide.go('<');
      });
    });

    // Handle custom next buttons
    document.querySelectorAll('.class-next').forEach(button => {
      button.addEventListener('click', () => {
        splide.go('>');
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var splideElement = document.getElementById("splideCategories");

  if (splideElement) {
    var splide = new Splide("#splideCategories", {
      type: "loop",
      drag: true,
      perPage: 4,
      pagination: false,
      autoplay: true,
      interval: 3000,
      perMove: 1,
      gap: "10px",
      breakpoints: {
        640: {
          perPage: 1,
        },
        767: {
          perPage: 2,
        },
        1024: {
          perPage: 2,
        },
        1210: {
          perPage: 3,
        },
      },
      classes: {
        arrows: "splide__arrows your-class-arrows",
        arrow: "splide__arrow your-class-arrow",
        prev: "splide__arrow--prev your-class-prev",
        next: "splide__arrow--next your-class-next",
      },
    }).mount();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Business Modal
  if (document.querySelector(".business-modal")) {
    document.querySelectorAll(".business-modal").forEach(function (element) {
      element.addEventListener("click", function () {
        document.getElementById("business-modal").style.display = "flex";
      });
    });

    document.getElementById("close-bus").addEventListener("click", function () {
      document.getElementById("business-modal").style.display = "none";
    });

    document.getElementById("business-modal").addEventListener("click", function (event) {
      if (event.target === document.getElementById("business-modal")) {
        document.getElementById("business-modal").style.display = "none";
      }
    });
  }

  // Accordion
  if (document.querySelector(".accordion-button")) {
    document.querySelectorAll(".accordion-button").forEach((button) => {
      button.addEventListener("click", () => {
        const accordionContent = button.nextElementSibling;
        const vertLine = button.querySelector(".vert-plus");

        button.classList.toggle("active");

        if (button.classList.contains("active")) {
          accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
          accordionContent.style.paddingTop = "20px";
          accordionContent.style.paddingBottom = "20px";
          vertLine.style.transform = "scaleY(0)";
        } else {
          accordionContent.style.maxHeight = null;
          accordionContent.style.paddingTop = "0px";
          accordionContent.style.paddingBottom = "0px";
          vertLine.style.transform = "scaleY(1)";
        }
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector("#splideFeatured")) {
    // Get all elements with the class '.product-card-variants'
    var productCardVariants = document.querySelectorAll(".product-card-variants");

    // Loop through each '.product-card-variants' element
    productCardVariants.forEach(function (productCardVariant) {
      // Get all '.variant' elements within the current '.product-card-variants'
      var variants = productCardVariant.querySelectorAll(".variant");

      // Create an array to store unique image URLs
      var uniqueImageUrls = [];

      // Loop through each '.variant' element
      variants.forEach(function (variant) {
        var image = variant.querySelector("img");
        if (image) {
          var imageUrl = image.src;

          if (!uniqueImageUrls.includes(imageUrl)) {
            uniqueImageUrls.push(imageUrl);
          } else {
            variant.parentNode.removeChild(variant);
          }
        }
      });
    });

    // Initialize the first Splide slider
    var splide = new Splide("#splideFeatured", {
      type: "loop",
      drag: false,
      arrows: true,
      autoplay: true,
      interval: 3000,
      perMove: 1,
      perPage: 4,
      pagination: false,
      gap: "10px",
      breakpoints: {
        640: {
          perPage: 1,
          drag: true
        },
        767: {
          perPage: 2,
          drag: true

        },
        1024: { perPage: 2 },
        1210: { perPage: 3 },
      },
      classes: {
        arrows: "splide__arrows your-class-arrows",
        arrow: "splide__arrow your-class-arrow",
        prev: "splide__arrow--prev your-class-prev",
        next: "splide__arrow--next your-class-next",
      },
    }).mount();

    // Function to change both main and hover images when a variant is clicked
    function changeImages(element, mainImageUrl, hoverImageUrl) {
      var slide = element.closest(".splide__slide");
      slide.querySelector(".main-image").src = mainImageUrl;
      slide.querySelector(".hover-image").src = hoverImageUrl;
      var siblings = element.parentElement.children;
      for (var i = 0; i < siblings.length; i++) {
        siblings[i].classList.remove("variant-active");
      }
      element.classList.add("variant-active");
    }

    // Function to handle hover behavior
    function initializeHoverEventListeners() {
      var imageContainers = document.querySelectorAll(".image-container");

      imageContainers.forEach(function (container) {
        var mainImage = container.querySelector(".main-image");
        var hoverImage = container.querySelector(".hover-image");

        container.addEventListener("mouseover", function () {
          mainImage.style.display = "none";
          hoverImage.style.display = "block";
        });

        container.addEventListener("mouseout", function () {
          mainImage.style.display = "block";
          hoverImage.style.display = "none";
        });
      });
    }

    // Initial initialization for hover event listeners
    initializeHoverEventListeners();

    // Attach click event listeners to variants
    var variants = document.querySelectorAll(".variant");
    variants.forEach(function (variant) {
      variant.addEventListener("click", function () {
        var mainImageUrl = variant.dataset.mainImageUrl;
        var hoverImageUrl = variant.dataset.hoverImageUrl;
        changeImages(variant, mainImageUrl, hoverImageUrl);
      });
    });

  }
});

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.size-nav')) {
    // Select all links within the 'size-nav' container
    var links = document.querySelectorAll('.size-nav a');

    // Add a click event listener to each link
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        // Remove 'link-active' class from all links
        links.forEach(function (lnk) {
          lnk.classList.remove('link-active');
        });

        // Add 'link-active' class to the clicked link
        event.currentTarget.classList.add('link-active');
      });
    });
  }
});

const slider = document.querySelector('.right-search');
let isDown = false;
let startX;
let scrollLeft;
let isDragging = false;

slider.addEventListener('mousedown', (e) => {
  isDown = true;
  isDragging = false;
  slider.classList.add('dragging');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});

slider.addEventListener('mouseleave', () => {
  isDown = false;
  slider.classList.remove('dragging');
});

slider.addEventListener('mouseup', () => {
  isDown = false;
  slider.classList.remove('dragging');
});

slider.addEventListener('mousemove', (e) => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 1.5; // Adjust scroll speed here
  slider.scrollLeft = scrollLeft - walk;
  isDragging = true;
});

// Prevent click if dragging
slider.querySelectorAll('a').forEach((link) => {
  link.addEventListener('click', (e) => {
    if (isDragging) {
      e.preventDefault();
    }
  });
});

let lastScrollY = window.scrollY;
const drawers = document.querySelectorAll('.mob-height-hun');

window.addEventListener('scroll', () => {
  const currentScroll = window.scrollY;

  drawers.forEach(drawer => {
    if (currentScroll < lastScrollY) {
      // Scrolling up
      drawer.classList.remove('scroll-up');
    } else {
      // Scrolling down
      drawer.classList.add('scroll-up');
    }
  });

  lastScrollY = currentScroll;
});

document.addEventListener("DOMContentLoaded", function () {
  // Get all modals and the close button
  const modals = document.querySelectorAll('.mobile-nav-modal, .sub-modal, .child-modal');
  const closeButton = document.querySelector('.close-all-modals');

  // Function to close all modals
  function closeAllModals() {
    modals.forEach(modal => {
      modal.style.display = 'none';
    });
  }

  // Event listener for the close button
  closeButton.addEventListener('click', function () {
    closeAllModals();
  });
});

// Function to open a modal
function openModal(modalId) {
  var modal = document.getElementById(modalId);
  modal.style.display = "block";
}

// Function to close a modal
function closeModal(modalId) {
  var modal = document.getElementById(modalId);
  modal.style.display = "none";
}

// Close the modal when the user clicks outside of it
window.onclick = function (event) {
  var modals = document.getElementsByClassName('modal');
  for (var i = 0; i < modals.length; i++) {
    if (event.target == modals[i]) {
      modals[i].style.display = "none";
    }
  }
}




